import { Injectable, inject } from '@angular/core';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { Nexus } from '@tomandco/nexus-api-types';
import './gtm-event-purchase';

@Injectable({
    providedIn: 'root'
})
export class GtmEventPurchaseTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    private init() {
        this.dfEventService.success(event => {
            if (event.id === 'nexusCheckoutSuccess' && event.result!.success.tracking) {
                this.dispatch(event, event.result!.success);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, data: Nexus.Api.Checkout.Success.Response['success']) {
        const dataRecord = data as unknown as Record<string, unknown>;
        const address = dataRecord['shipping'] ?? dataRecord['billing'] ?? dataRecord['shipping_address'] ?? dataRecord['billing_address'];
        const addressData = address as { postcode?: string; telephone?: string; country_id?: string } | undefined;
        const customerData = dataRecord['customer'] as { email?: string } | undefined;

        return this.gtmService.dispatch({
            event: 'purchase',
            triggerContext: {
                trigger
            },
            ecommerce: {
                ...(await this.gtmDataService.getEventData(data.items?.map(item => this.gtmDataService.orderItemToGtmItem(item)) || [])),
                coupon: data['coupon_code'], // TODO: restore no branckets and fix deps
                transaction_id: data.number!,
                value: data.totals.grand_total,
                tax: data.totals.tax || 0,
                shipping: data.totals.delivery || 0,
                email: customerData?.email ?? undefined,
                phone: addressData?.telephone ?? undefined,
                postal_code: addressData?.postcode ?? undefined,
                country: addressData?.country_id ?? undefined,
                payment_type: data.payment_method?.code
            }
        });
    }
}
